import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { id: "style-4" }
const _hoisted_2 = { className: "card card-custom" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { className: "card-header border-0" }, [
  /*#__PURE__*/_createVNode("h3", { className: "card-title font-weight-bolder text-dark" }, " Pré-Cadastro de Laudos "),
  /*#__PURE__*/_createVNode("div", { className: "card-toolbar" }, [
    /*#__PURE__*/_createVNode("button", {
      className: "btn btn-primary font-weight-bolder font-size-sm mr-3 d-flex",
      "data-bs-toggle": "modal",
      "data-bs-target": "#pryal_cliente_cadastro"
    }, [
      /*#__PURE__*/_createVNode("i", { class: "bi bi-person-plus-fill fs-3" })
    ])
  ])
], -1)
const _hoisted_4 = { className: "d-flex flex-wrap align-items-center" }
const _hoisted_5 = { className: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3" }
const _hoisted_6 = { class: "fs-3" }
const _hoisted_7 = { className: "font-size-sm" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "bi bi-card-checklist" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Criar laudo ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClienteCadastro = _resolveComponent("ClienteCadastro")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.clientes, (c) => {
          return (_openBlock(), _createBlock("div", {
            className: "card-body pt-2",
            key: c.id
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("a", {
                  href: "#pryal_cliente_cadastro",
                  onClick: ($event: any) => (_ctx.setCliente(c)),
                  "data-bs-toggle": "modal"
                }, [
                  _createVNode("span", _hoisted_6, _toDisplayString(c.nome), 1)
                ], 8, ["onClick"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(c.veiculos, (veiculo) => {
                  return (_openBlock(), _createBlock("span", {
                    key: veiculo.id,
                    className: "d-flex align-items-center justify-content-between text-muted mb-3"
                  }, [
                    _createVNode("span", _hoisted_7, _toDisplayString(veiculo.marca) + " " + _toDisplayString(veiculo.modelo) + " | Placa " + _toDisplayString(veiculo.placa), 1),
                    _createVNode("button", {
                      class: "btn btn-sm btn-light-primary",
                      onClick: ($event: any) => (_ctx.criarLaudo(c, veiculo))
                    }, [
                      _hoisted_8,
                      _hoisted_9
                    ], 8, ["onClick"])
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_ClienteCadastro, { cliente: _ctx.cliente }, null, 8, ["cliente"])
  ], 64))
}